module.exports = __webpack_public_path__ + "media/newstyle/images/100-mil-book-aus-b7834d4a17903cdfb49c52e9a0ccb841.svg";